import type { IconData } from '@stacksjs/iconify-core'

export const pin2Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M29 1.5c-9.665 0-17.5 7.835-17.5 17.5S19.335 36.5 29 36.5S46.5 28.665 46.5 19S38.665 1.5 29 1.5m-8.486 11.843a2 2 0 0 1 0-2.828c4.686-4.687 12.284-4.687 16.97 0a2 2 0 0 1-2.828 2.828a8 8 0 0 0-11.314 0a2 2 0 0 1-2.829 0m-1.027 23.82a20.6 20.6 0 0 1-8.65-8.65c-1.672 2.36-3.285 4.665-4.673 6.742c-1.519 2.274-2.81 4.338-3.631 5.95c-.406.797-.737 1.56-.905 2.224a3.6 3.6 0 0 0-.123 1.108c.026.398.156.932.591 1.367s.97.565 1.367.591a3.6 3.6 0 0 0 1.108-.123c.664-.169 1.427-.5 2.223-.905c1.613-.82 3.677-2.112 5.95-3.632c2.078-1.387 4.382-3 6.743-4.671\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pin2Solid
